// Shared decorative icons preserve the visible text as each link's accessible name.
const NAV_ICON_PATHS: Record<string, string> = {
  '/dashboard': 'M3 10.5 12 3l9 7.5M5.5 9v11h13V9M9.5 20v-6h5v6',
  '/tap': 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM5 20a7 7 0 0 1 14 0H5Z',
  '/card-design': 'M3.5 6.5h17v11h-17zM3.5 10h17M7 14h4',
  '/orders': 'M12 2.5 21 7v10l-9 4.5L3 17V7l9-4.5ZM3 7l9 4.5L21 7M12 11.5v10',
  '/analytics': 'M5 20V12M12 20V4M19 20V8',
  '/contacts': 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM3 20a6 6 0 0 1 12 0H3ZM16 5a3 3 0 0 1 0 6M17 14a5 5 0 0 1 4 5',
  '/team': 'M8 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM2.5 20a5.5 5.5 0 0 1 11 0h-11ZM16 12a3 3 0 1 0 0-6M16 14a5 5 0 0 1 5 5',
  '/plan-billing': 'M3 6h18v12H3zM3 10h18M6 15h4',
  '/settings': 'M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6 7 7M17 17l1.4 1.4M18.4 5.6 17 7M7 17l-1.4 1.4M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z'
};


export function CustomerNavigationIcon({ to, className }: { to: string; className: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d={NAV_ICON_PATHS[to]} />
    </svg>
  );
}
